(function(){
    'use strict';

    angular
        .module('elogbooksControllers')
        .controller('SiteSearchFiltersModalController', SiteSearchFiltersModalController);

    function SiteSearchFiltersModalController($uibModalInstance, restrictOne, filters, userManager) {
        var vm = this;
        vm.expandedSearchForm = angular.extend({
            regionSelect : {
                link : '/regions',
                responseKeyPath: 'regions'
            },
            sectorSelect : {
                link : '/sectors',
                responseKeyPath: 'sectors'
            },
            siteGroupSelect : {
                link : '/sitegroups',
                responseKeyPath: 'sitegroups'
            },
            coreClientSelect : {
                link : '/coreclients',
                responseKeyPath: 'coreclients'
            },
            name: '',
            reference: '',
            restrictOne: restrictOne
        }, filters);

        if (filters?.siteRegion) {
            vm.expandedSearchForm.regionSelect.selectedItems = [filters?.siteRegion.id];
            vm.expandedSearchForm.regionSelect.selected = filters?.siteRegion;
        }

        if (filters?.sector) {
            vm.expandedSearchForm.sectorSelect.selectedItems = [filters?.sector.id];
            vm.expandedSearchForm.sectorSelect.selected = filters?.sector;
        }

        if (filters?.siteGroup) {
            vm.expandedSearchForm.siteGroupSelect.selectedItems = [filters?.siteGroup.id];
            vm.expandedSearchForm.siteGroupSelect.selected = filters?.siteGroup;
        }

        if (filters?.coreClient) {
            vm.expandedSearchForm.coreClientSelect.selectedItems = [filters?.coreClient.id];
            vm.expandedSearchForm.coreClientSelect.selected = filters?.coreClient;
        }

        vm.submit = submitAction;
        vm.close = closeAction;
        vm.userSiteLink = userManager.getUser();

        function submitAction() {
            $uibModalInstance.close(vm.expandedSearchForm);
        }

        function closeAction() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
